import { create } from "zustand";

export const useStoreAllStaticData = create((set, get) => ({
  typeResi: [],
  versementMethod: [],
  reservationPreviewPrice: null,
  handleUpdateVersementMethod: (payload) => {
    set(() => ({ versementMethod: payload }));
  },
  handleUpdateTypeResi: (payload) => {
    set(() => ({ typeResi: payload }));
  },
  handleUpdateReservationPreviewPrice: (payload) => {
    set(() => ({ reservationPreviewPrice: payload }));
  },
}));
